<template>
    <div class="inline-block w-full" id="top">
        <Breadcrumb :current="4" />

        <div class="flex items-center bg-[#e96932] rounded-t-[8px] py-[15px] px-[20px]">
            <h4 class="text-[#fff]">{{ valutazione?.dettagli?.marca?.nome }} {{ valutazione?.dettagli?.modelloBreveCarrozzeria }}
                <span v-if="valutazione?.mese && valutazione?.anno" class="normal-case font-light"> {{ valutazione.mese }}/{{ valutazione.anno }}</span>
            </h4>
        </div>
        
        <div class="bg-[#fff] flex justify-center items-center w-full h-[350px] border border-[#e96932] rounded-b-[8px]">
            <img v-if="foto?.length > 0" :src="foto[0]?.url" class="max-h-full relative text-black rounded-b-[8px] p-[10px]" :alt="valutazione?.modello?.modello">
        </div>

        <div v-for="(per, idxP) in perizie" :key="idxP" class="border border-[#e96932] rounded-[10px] mt-[30px] pb-[10px]">
            <div class="flex items-center bg-[#e96932] rounded-t-[8px] py-[15px] px-[20px]">
                <div class="flex justify-between items-center w-full">
                    <h4 class="text-[#fff]">{{ per?.dettagli?.nome }}</h4>
                    <div v-if="mainStore.abbonato?.adm" class="flex justify-end">
                        <button v-if="isValutazioneSaved[idxP]" title="Rimuovi perizia" class="button py-[5px] px-[10px]" @click="unsavePerizia(per, idxP)">
                            <font-awesome-icon icon="fa-solid fa-star" />
                        </button>
                        <button v-else class="button py-[5px] px-[10px]" title="Salva perizia" @click="savePerizia(per, idxP)">
                            <font-awesome-icon icon="fa-regular fa-star" />
                        </button>
                        <button v-if="isValutazioneSaved[idxP]" title="Invia tramite email" class="button ml-[8px] py-[5px] px-[10px]" @click="this.isEmailOpen[idxP] = !this.isEmailOpen[idxP]">
                            <font-awesome-icon icon="fa-solid fa-envelope" />
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="isEmailOpen[idxP]" class="flex items-center my-[20px] px-[10px]">
                <input type="text" placeholder="Email" v-model="email" />
                <button class="button ml-[5px] py-[10px] px-[10px]" @click="sendEmail(per)">
                    <span>Invia</span>
                </button>
            </div>

            <div class="flex justify-between mt-[10px] px-[10px]">
                <div class="w-[49%] text-center border border-[#166fff] rounded-[10px]">
                    <h4 class="text-[1rem] text-bold text-center text-[#fff] bg-[#166fff] rounded-t-[8px] p-[10px]">EUROTAX BASE</h4>
                    <div class="flex flex-col sm:flex-row justify-center items-center gap-[5px] py-[10px]">
                        <div>
                            <div class="flex items-center justify-center">
                                <h3 v-if="formatNumber(per?.valutazione?.quotazioneBlu) > 0" class="text-[1.5rem] text-bold mb-0">€ </h3>
                                <h3 class="text-[1.5rem] text-bold mb-0">{{ formatNumber(per?.valutazione?.quotazioneBlu) }}</h3>
                            </div>

                            <span class="text-[.625rem] block mt-[5px]">Valore di ritiro</span>
                        </div>
                        
                        <button v-if="mainStore.type == 'auto' && mainStore.abbonato?.adm && mainStore.isSendingCorrectionAvailable" class="button py-[5px] px-[10px]" @click="openEditValutation(per, idxP)">
                            <font-awesome-icon v-if="!isEditCorrectionOpen[idxP]" icon="fa-solid fa-pen-to-square" title="Aggiungi quotazione" class="cursor-pointer" />
                            <font-awesome-icon v-else icon="fa-solid fa-rotate-left" title="Annulla quotazione" class="cursor-pointer" />
                        </button>
                    </div>
                </div>

                <div class="w-[49%] text-center border border-[#fce54e] rounded-[10px]">
                    <h4 class="text-[1rem] text-bold text-center text-[#000] bg-[#fce54e] rounded-t-[8px] p-[10px]">EUROTAX BASE</h4>
                    <div class="py-[10px] px-[20px]">
                        <div class="flex items-center justify-center">
                            <h3 v-if="formatNumber(per?.valutazione?.quotazioneGialla) > 0" class="text-[1.5rem] text-bold mb-0">€ </h3>
                            <h3 class="text-[1.5rem] text-bold mb-0">{{ formatNumber(per?.valutazione?.quotazioneGialla) }}</h3>
                        </div>
                        
                        <span class="text-[.625rem] block mt-[5px]">Valore di vendita</span>
                    </div>
                </div>
            </div>

            <div v-if="isEditCorrectionOpen[idxP]" class="w-[47%] text-center border border-[#166fff] rounded-[10px] mt-[10px] ml-[10px]">
                <h4 class="text-[1rem] text-bold text-center text-[#fff] bg-[#166fff] rounded-t-[8px] p-[10px]">QUOTAZIONE DEALER</h4>
                <div class="flex flex-col sm:flex-row justify-center items-center gap-[5px] py-[10px]">
                    <div class="flex items-center justify-center">
                        <h3 class="text-[1.5rem] text-bold mr-[5px] mb-0">€</h3>
                        <input type="number" :placeholder="formatNumber(per?.valutazione?.quotazioneBlu)" v-model="blueCorrectionSelected" min="1" class="max-w-[130px]" />
                    </div>
                    <button v-if="isEditCorrectionOpen[idxP]" class="button cursor-pointer py-[5px] px-[10px]" 
                        :disabled="!this.blueCorrectionSelected" @click="sendCorrection(idxP)">
                        <font-awesome-icon icon="fa-solid fa-floppy-disk" title="Salva quotazione" />
                    </button>
                </div>
            </div>
            
            <div class="flex justify-between mt-[10px] px-[10px]">
                <div class="w-[49%] text-center border border-[#166fff] rounded-[10px]">
                    <h4 class="text-[1rem] text-bold text-center text-[#fff] bg-[#166fff] rounded-t-[8px] p-[10px]">CORREZIONE CHILOMETRICA</h4>
                    <div class="py-[10px] px-[20px]">
                        <div class="flex items-center justify-center">
                            <h3 v-if="formatKmCorrection(per?.valutazione?.quotazioneBluKm, per?.valutazione?.quotazioneBlu) > 0" class="text-[1.5rem] text-bold mb-0">€ </h3>
                            <h3 class="text-[1.5rem] text-bold mb-0"> {{ formatKmCorrection(per?.valutazione?.quotazioneBluKm, per?.valutazione?.quotazioneBlu) }}</h3>
                        </div>
                        <span class="text-[.625rem] block mt-[5px]">Valore di ritiro</span>
                    </div>
                </div>
                <div class="w-[49%] text-center border border-[#fce54e] rounded-[10px]">
                    <h4 class="text-[1rem] text-bold text-center text-[#000] bg-[#fce54e] rounded-t-[8px] p-[10px]">CORREZIONE CHILOMETRICA</h4>
                    <div class="py-[10px] px-[20px]">
                        <div class="flex items-center justify-center">
                            <h3 v-if="formatKmCorrection(per?.valutazione?.quotazioneGiallaKm, per?.valutazione?.quotazioneGialla) > 0" class="text-[1.5rem] text-bold mb-0">€ </h3>
                            <h3 class="text-[1.5rem] text-bold mb-0">{{ formatKmCorrection(per?.valutazione?.quotazioneGiallaKm, per?.valutazione?.quotazioneGialla) }}</h3>
                        </div>
                        <span class="text-[.625rem] block mt-[5px]">Valore di vendita</span>
                    </div>
                </div>
            </div>
        </div>    

        <SchedaTecnica v-if="valutazione?.veicolo" />

        <div v-if="perizie?.length > 1" class="flex justify-end mt-[30px]">
            <div class="button py-[5px] px-[10px]" @click="goUp">
                <label class="mr-[5px]">Torna su</label>
                <font-awesome-icon icon="fa-solid fa-arrow-up" class="h-[20px]"/>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue';
import SchedaTecnica from '../components/SchedaTecnica.vue';
import { mainStore } from '../../store/main';
import axios from 'axios';
import formatter from "../formatter";
import moment from "moment";

export default {
    name: 'PeriziaView',
    components: { Breadcrumb, SchedaTecnica },

    data() {
        return {
            mainStore,
            valutazione: {},
            perizie: [],
            note: null,
            isEmailOpen: [],
            email: null,
            isEditCorrectionOpen: [],
            blueCorrections: [],
            blueCorrectionSelected: null,
            isValutazioneSaved: [],
            foto: {}
        }
    },

    async created() {
        const loader = this.$loading.show();
        
        this.valutazione = { ...this.mainStore.perizia };

        if(this.mainStore.type != "auto") {
            const perizie = await this.getPerizie();
            this.perizie = this.mainStore.perizie.map((item, index) => {
                const perizia = perizie?.find(per => per?.codiceEurotax == item?.dettagli?.codiceEurotax);
                if(perizia) {
                    this.isValutazioneSaved[index] = true;
                    item.id = perizia?.id;
                } else {
                    this.isValutazioneSaved[index] = false;
                }
                
                this.isValutazioneSaved[index] = true;
                this.isEditCorrectionOpen[index] = false;
                this.isEmailOpen[index] = false;

                return item;
            });
        } else {
            this.perizie = this.mainStore.perizie.map((item, index) => {                
                this.isValutazioneSaved[index] = false;
                this.isEditCorrectionOpen[index] = false;
                this.isEmailOpen[index] = false;

                return item;
            });
        }

        this.foto = await this.getFoto();
        
        loader.hide();
    },

    methods: {
        async getFoto() {
            try {
                const response = await axios.get(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/proxy/usato/${this.mainStore.type}/foto?codice_eurotax=${this.perizie[0]?.dettagli?.codiceEurotax}`)

                return [ ...response.data?.immagini ];
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel caricamento della foto",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "warn",
                });
            }
        },
        async getPerizie() { 
            try {
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${this.mainStore.type}/search`,
                    { headers: { "content-type": "application/json" } });

                return response.data?.perizie;
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: `Errore perizie ${this.mainStore.type}`,
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async unsavePerizia(data, index) {
            const loader = this.$loading.show();
        
            try {           
                await axios.delete(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${this.mainStore.type}/${data?.id}`, 
                    { headers: { "content-type": "application/json" } });
                
                this.isValutazioneSaved[index] = false;

                this.$notify({
                    title: "Perizia rimossa con successo",
                    type: "success",
                });
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella rimozione della perizia",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async savePerizia(data, index) {
            const loader = this.$loading.show();

            try {                
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${this.mainStore.type}`, {
                    accessori: [],
                    calcoloValutazione: {
                        codiceEurotax: data?.dettagli?.codiceEurotax,
                        annoImmatricolazione: this.valutazione?.annoImmatricolazione,
                        annoValiditaPerizia: moment().format("YYYY").toString(),
                        meseValiditaPerizia: moment().format("M").toString(),
                        meseImmatricolazione: this.valutazione?.meseImmatricolazione,
                        km: this.mainStore.kmPerizia < 1 ? "" : this.mainStore.kmPerizia,
                        ignoraVariazioneKm: false                              
                    },
                    cliente: {},
                    configAccessori: null,
                    danni: {},
                    datiAggiuntiviCalcolo: {
                        dannoRilevato: null,
                        esposizioneIva: null,
                        statoMedioVeicolo: null,
                        totaleAccessori: 0,
                        correzioni: {
                            correzioneZona: {},
                            correzioneAzienda: {}
                        }
                    },
                    nota: "",
                    personalizzazione: {},
                    riparazioniCarrozzeria: {},
                    riparazioniMeccanica: {},
                    spese: {},
                    superValutazioni: [],
                    veicolo: {}
                }, { headers: { "content-type": "application/json" } })
        
                this.isValutazioneSaved[index] = true;
                this.perizie[index] = { ...this.perizie[index], id: response?.data?.dati?.id };
                
                this.$notify({
                    title: "Perizia salvata con successo",
                    type: "success",
                });                
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel salvataggio della perizia",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });   
            }

            loader.hide();
        },
        formatKmCorrection(valueKm, value) {
            if(valueKm > 0) {
                return this.formatNumber(valueKm);
            }
            return this.formatNumber(value);
        },  
        format(date, initialFormat, finalFormat) {
            if(!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },  
        goUp() {
            document.getElementById('top').scrollIntoView({behavior: 'smooth'});
        },
        async getBlueCorrection(index) {
            try {                
                const response = await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/get-blue-correction`, {
                    codice_cliente: this.mainStore.utente?.abbonatoId,
                    codice_utente: this.mainStore.utente?.id,
                    codice_eurotax: this.mainStore.perizie[index]?.dettagli?.codiceEurotax,
                    anno: this.mainStore.perizia?.annoImmatricolazione,
                    mese: this.mainStore.perizia?.meseImmatricolazione
                }, { headers: { "content-type": "application/x-www-form-urlencoded" } })
                
                return response;
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nella ricerca della correzione consigliata",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }
        },
        async sendCorrection(index) {
            const loader = this.$loading.show();

            try {
                let bluKm = this.mainStore.perizie[index]?.valutazione?.quotazioneBlu;
                if(this.mainStore.perizie[index]?.valutazione?.quotazioneBluKm > 0) {
                    bluKm = this.mainStore.perizie[index]?.valutazione?.quotazioneBluKm;
                }

                let gialloKm = this.mainStore.perizie[index]?.valutazione?.quotazioneGialla;
                if(this.mainStore.perizie[index]?.valutazione?.quotazioneGiallaKm > 0) {
                    gialloKm = this.mainStore.perizie[index]?.valutazione?.quotazioneGiallaKm;
                }
                
                await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/store-blue-correction`, {
                    codice_cliente: this.mainStore.utente?.abbonatoId,
                    codice_utente: this.mainStore.utente?.id,
                    codice_eurotax: this.mainStore.perizie[index]?.dettagli?.codiceEurotax,
                    anno: this.mainStore.perizia?.annoImmatricolazione,
                    mese: this.mainStore.perizia?.meseImmatricolazione,
                    blu: this.mainStore.perizie[index]?.valutazione?.quotazioneBlu,
                    giallo: this.mainStore.perizie[index]?.valutazione?.quotazioneGialla,
                    blu_km: bluKm,
                    giallo_km: gialloKm,
                    blu_suggerito: this.blueCorrectionSelected,
                    km: this.mainStore.kmPerizia != null ? this.mainStore.kmPerizia : 0
                }, { headers: { "content-type": "application/x-www-form-urlencoded" } })

                this.blueCorrections = this.blueCorrections.map(item => {
                    if(item.codiceEurotax == this.mainStore.perizie[index]?.dettagli?.codiceEurotax) {
                        item.bluSuggerito = this.blueCorrectionSelected
                    }

                    return item;
                })

                this.$notify({
                    title: "Quotazione dealer salvata correttamente",
                    type: "success",
                });
            } catch(error) {
                console.log("e", error);
                this.$notify({
                    title: "Errore nel salvataggio",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        async openEditValutation(perizia, idx) {
            const loader = this.$loading.show();

            try {
                const codiceEurotax = parseInt(perizia?.dettagli?.codiceEurotax);

                if(! this.blueCorrections.find(item => item?.codiceEurotax == codiceEurotax)) {
                    const result = await this.getBlueCorrection(idx);
                    this.blueCorrections.push({ codiceEurotax, bluSuggerito: result.data?.bluSuggerito });
                }

                this.blueCorrectionSelected = this.blueCorrections.find(item => item?.codiceEurotax == codiceEurotax)?.bluSuggerito;
                this.isEditCorrectionOpen = this.isEditCorrectionOpen.map((item, index) => {
                    if(index == idx) {
                        item = !item;
                    } else {
                        item = false;
                    }

                    return item;
                })
            } catch(error) {
                console.log("e", error);
            }

            loader.hide();
        },
        async sendEmail(data) {
            if(!this.email) {
                this.$notify({
                    title: "Attenzione",
                    text: "Email mancante",
                    type: "warn",
                });
                return;
            }

            const loader = this.$loading.show();
            
            try {
                await axios.post(`${process.env.VUE_APP_HOST}/${process.env.VUE_APP_VERSION}/admonline/perizia/${this.mainStore.type}/mail/${data?.id}`, {
                    blu: true,
                    giallo: true,
                    nota: false,
                    sezioni: {},
                    tipo: "QUOTAZIONE",
                    to: this.email
                })

                this.$notify({
                    title: "Email inviata con successo",
                    type: "success",
                });
            } catch(error) {
                console.log("e", error);                
                this.$notify({
                    title: "Errore nell'invio dell'email",
                    text: error?.response?.data?.message ? error.response.data.message : error?.response?.statusText,
                    type: "error",
                });
            }

            loader.hide();
        },
        formatNumber(number) {
            if (number > 0) {
                const result = Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(number);
                return result.split(",")[0];
            } else {
                return "N.D.";
            }
        },
    },
}
</script>